import { useAuth } from '../auth';

export function LoginPage() {
  const { login } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full mx-4">
        <div className="bg-card rounded-2xl border border-border shadow-xl p-8">
          <div className="text-center mb-8">
            <img
              src="/pixacore-logo.png"
              alt="Coretex"
              className="h-16 w-16 rounded-xl mx-auto mb-4"
            />
            <h1
              className="text-2xl font-bold text-foreground flex items-center justify-center gap-px"
              style={{ fontFamily: 'Montserrat, Inter, sans-serif', letterSpacing: '0.06em' }}
            >
              <span>C</span>
              <span className="text-primary">O</span>
              <span>RETEX</span>
            </h1>
            <p
              className="text-muted-foreground mt-1 text-sm"
              style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
            >
              Marketplace
            </p>
          </div>

          <div className="space-y-4">
            <p className="text-sm text-muted-foreground text-center">
              Sign in with your Pixacore account to access the internal
              marketplace for Claude Code skills and MCP servers.
            </p>

            <button
              onClick={login}
              className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium"
            >
              <svg className="w-5 h-5" viewBox="0 0 21 21" fill="currentColor">
                <path d="M0 0h10v10H0V0zm11 0h10v10H11V0zM0 11h10v10H0V11zm11 0h10v10H11V11z" />
              </svg>
              Sign in with Microsoft
            </button>
          </div>

          <p className="text-xs text-muted-foreground text-center mt-6">
            This is an internal tool for Pixacore team members only.
          </p>
        </div>
      </div>
    </div>
  );
}
